import * as React from 'react';
import { Form, Col, Button, Row } from 'react-bootstrap';
import { wrapInput, wrapCheckbox } from '../../common/FormChangeWrapper';

interface Props {
    username: string;
    password: string;
    rememberMe: boolean;
    onChange: (fieldName: string, value: string) => void;
    onChangeCheckbox: (value: boolean) => void;
    onSubmit: () => void;
}


export const LoginForm: React.StatelessComponent<Props> = (props) => {
    return (
        <Row>
            <Col sm={{ span: 4, offset: 4 }} className="login-form">
                <Row>
                    <Col sm={6} className="text-left">
                        <br />
                        <h4>Вход в систему</h4>
                    </Col>
                </Row>
                <Form onSubmit={(e: any) => {
                    e.preventDefault();
                }}>
                    <hr />
                    <Form.Group as={Row} controlId="formHorizontalEmail">
                        <Form.Label column >
                            Логин
                    </Form.Label>
                        <Col sm={9}>
                            <Form.Control type="email" name="username" onChange={wrapInput(props.onChange)} placeholder="Введите email" />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formHorizontalPassword">
                        <Form.Label column>
                            Пароль
                    </Form.Label>
                        <Col sm={9}>
                            <Form.Control type="password" name="password" onChange={wrapInput(props.onChange)} placeholder="Введите пароль" />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formRememberCheck">
                        <Col sm={{ span: 9, offset: 3 }} >
                            <Form.Check type="checkbox" checked={props.rememberMe} onChange={wrapCheckbox((fieldName: string, value: string, checked: boolean) => {
                                props.onChangeCheckbox(checked)
                            })} label="Запомнить меня" />
                        </Col>
                    </Form.Group>
                    <Row>
                        <Col sm={12} className="text-center">
                            <Button type="submit" onClick={props.onSubmit} className="btn btn-default btn-lg login-btn">Войти</Button>
                        </Col>
                    </Row>
                </Form >
            </Col>
        </Row>
    );
};